const TreeNode = require('../TreeNode');
const BattleCalc = require('../../BattleCalc');
const Q_which_aoe = require('./Q_which_aoe');
const Q_better_to_melee = require('./Q_better_to_melee');
const AICalc = require('../AICalc');

const DPSRangedDecision = function (actor, battleState) {
  const node = new TreeNode(actor, battleState);

  node.arrowShot = BattleCalc.getEquippedAbility(actor, 'arrow_shot');
  node.voidSpike = BattleCalc.getEquippedAbility(actor, 'void_spike');
  node.infectMind = BattleCalc.getEquippedAbility(actor, 'infect_mind');
  node.razorShot = BattleCalc.getEquippedAbility(actor, 'razor_shot');

  node.branches.YES_CLUSTER = new Q_which_aoe(actor, battleState);
  node.branches.NO_CLUSTER = new Q_better_to_melee(actor, battleState);

  const originalDispose = node.dispose;
  node.dispose = function() {
    node.arrowShot = null;
    node.voidSpike = null;
    node.infectMind = null;
    node.razorShot = null;
    originalDispose.call(node);
  };

  node.query = function () {
    const bestTarget = AICalc.getBestMissileTarget(actor, battleState);
    if (!bestTarget) {
      return null;
    }

    // if there is a cluster of enemies, we'll try to use an AoE attack
    const enemyCluster = AICalc.defineEnemyCluster(
      bestTarget,
      battleState.getEnemiesOfUnit(actor)
    );

    if (
      enemyCluster.length > 2 ||
      (!node.arrowShot && !node.voidSpike && !node.infectMind && !node.razorShot)
    ) {
      return node.branches.YES_CLUSTER.query(bestTarget);
    } else {
      return node.branches.NO_CLUSTER.query(bestTarget);
    }
  };

  return node;
};
module.exports = DPSRangedDecision;
